import { intercomTrackEvent } from '../../../../../analytics/intercomService';
import { sendAmplitudeEvent } from '../../../../../analytics/amplitudeService';
import { AMPLITUDE_USER_PROPS, TRACKED_FEATURES } from '../../../../../../common/analytics/statsConstants';

export enum ImageModalFlipDirection {
    HORIZONTAL = 'Horizontal',
    VERTICAL = 'Vertical',
}

const backgroundRemovalFeatureUserProperties = {
    [AMPLITUDE_USER_PROPS.FEATURE]: { [TRACKED_FEATURES.IMAGE_BACKGROUND_REMOVAL]: true },
};

/**
 * Track a provider-backed background-removal action from the image modal.
 */
export const trackImageBackgroundRemovalClicked = (): void => {
    sendAmplitudeEvent({
        eventType: 'Image background removal clicked',
        userProperties: backgroundRemovalFeatureUserProperties,
    });

    intercomTrackEvent('removed-image-background');
};

/**
 * Track usage of the image-modal flip controls.
 */
export const trackImageModalFlip = (direction: ImageModalFlipDirection): void => {
    sendAmplitudeEvent({
        eventType: 'Image flipped',
        eventProperties: {
            direction,
        },
    });

    intercomTrackEvent('flipped-image');
};
